import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, Input, Button } from 'reactstrap';
import { Search, Filter, X } from 'react-feather';
import appQuizApi from '../../../api/appQuiz';

const FilterBar = ({ filters, onFilterChange, onApplyFilters, onResetFilters }) => {
  const [quizOptions, setQuizOptions] = useState([]);
  const [loadingQuizzes, setLoadingQuizzes] = useState(false);

  // Load quiz options on mount
  useEffect(() => {
    loadQuizOptions();
  }, []);

  const loadQuizOptions = async () => {
    try {
      setLoadingQuizzes(true);
      const response = await appQuizApi.getAllQuizTemplates({ limit: 500 });
      
      const quizzes = 
        response?.data?.quizzes || 
        response?.data?.quizTemplates || 
        response?.quizzes || 
        response?.quizTemplates || 
        response?.data || 
        response || 
        [];

      const options = Array.isArray(quizzes)
        ? quizzes
            .map((quiz) => {
              const id = quiz.id || quiz.quizId;
              if (!id) return null;
              const name = quiz.name || quiz.title || `Quiz #${id}`;
              return { id, name };
            })
            .filter(Boolean)
            .sort((a, b) => a.name.localeCompare(b.name)) // Sort by name
        : [];

      setQuizOptions(options);
    } catch (error) {
      console.error('Error loading quiz options:', error);
      setQuizOptions([]);
    } finally {
      setLoadingQuizzes(false);
    }
  };

  return (
    <>
      <Card className="bg-light border-0 filter-bar-compact">
        <CardBody className="p-2">
          <Row className="g-2 align-items-end">
            <Col md="2" sm="6" xs="12">
              <label className="small fw-bold mb-1 d-block">
                <Search size={12} className="me-1" />
                Tìm kiếm
              </label>
              <Input
                type="text"
                placeholder="User ID, tên, SĐT..."
                value={filters.search}
                onChange={(e) => onFilterChange('search', e.target.value)}
                bsSize="sm"
                className="filter-input"
              />
            </Col>
            <Col md="2" sm="6" xs="12">
              <label className="small fw-bold mb-1 d-block">
                <Filter size={12} className="me-1" />
                Quiz (tên)
              </label>
              <Input
                type="select"
                value={filters.quizName || ''}
                onChange={(e) => onFilterChange('quizName', e.target.value)}
                disabled={loadingQuizzes}
                bsSize="sm"
                className="filter-input"
              >
                <option value="">Tất cả</option>
                {quizOptions.map((quiz) => (
                  <option key={quiz.id} value={quiz.name}>
                    {quiz.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md="2" sm="6" xs="12">
              <label className="small fw-bold mb-1 d-block">
                <Filter size={12} className="me-1" />
                Quiz (ID)
              </label>
              <Input
                type="select"
                value={filters.quizId || ''}
                onChange={(e) => onFilterChange('quizId', e.target.value)}
                disabled={loadingQuizzes}
                bsSize="sm"
                className="filter-input"
              >
                <option value="">Tất cả</option>
                {quizOptions.map((quiz) => (
                  <option key={quiz.id} value={quiz.id}>
                    {quiz.name} (ID: {quiz.id})
                  </option>
                ))}
              </Input>
            </Col>
            <Col md="2" sm="6" xs="12">
              <label className="small fw-bold mb-1 d-block">
                <Filter size={12} className="me-1" />
                Role
              </label>
              <Input
                type="select"
                value={filters.role_code}
                onChange={(e) => onFilterChange('role_code', e.target.value)}
                bsSize="sm"
                className="filter-input"
              >
                <option value="">Tất cả</option>
                <option value="user">User</option>
                <option value="admin">Admin</option>
                <option value="moderator">Moderator</option>
              </Input>
            </Col>
            <Col md="2" sm="6" xs="12">
              <label className="small fw-bold mb-1 d-block">
                <Filter size={12} className="me-1" />
                Followed OA
              </label>
              <Input
                type="select"
                value={filters.followedOA}
                onChange={(e) => onFilterChange('followedOA', e.target.value)}
                bsSize="sm"
                className="filter-input"
              >
                <option value="">Tất cả</option>
                <option value="true">Đã follow</option>
                <option value="false">Chưa follow</option>
              </Input>
            </Col>
            <Col md="2" sm="6" xs="12" className="d-flex gap-1">
              <Button 
                color="primary" 
                onClick={onApplyFilters} 
                size="sm"
                className="flex-grow-1 filter-btn"
              >
                <Filter size={12} className="me-1" />
                Lọc
              </Button>
              <Button 
                color="secondary" 
                outline 
                onClick={onResetFilters}
                size="sm"
                className="filter-btn-reset"
              >
                <X size={12} />
              </Button>
            </Col>
          </Row>
          {loadingQuizzes && (
            <Row>
              <Col>
                <small className="text-muted">
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Đang tải danh sách quiz...
                </small>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      <style>{`
        .filter-bar-compact .card-body {
          padding: 0.5rem !important;
        }
        .filter-bar-compact label {
          font-size: 0.75rem;
          margin-bottom: 0.25rem;
          color: #6c757d;
        }
        .filter-bar-compact .filter-input {
          font-size: 0.875rem;
          padding: 0.375rem 0.5rem;
          height: calc(1.5em + 0.5rem + 2px);
        }
        .filter-bar-compact .filter-btn,
        .filter-bar-compact .filter-btn-reset {
          font-size: 0.875rem;
          padding: 0.375rem 0.75rem;
          height: calc(1.5em + 0.5rem + 2px);
        }
        .filter-bar-compact .filter-btn-reset {
          min-width: 38px;
        }
        .filter-bar-compact .row {
          margin-left: -0.25rem;
          margin-right: -0.25rem;
        }
        .filter-bar-compact .row > * {
          padding-left: 0.25rem;
          padding-right: 0.25rem;
        }
        @media (max-width: 768px) {
          .filter-bar-compact .col-md-2,
          .filter-bar-compact .col-sm-6 {
            margin-bottom: 0.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default FilterBar;

